import { Component, OnInit, Input } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { LocalDataSource } from 'ng2-smart-table';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { SysUsersService } from '../services/sys-users.service';
import { EditSysUsersComponent } from '../edit-sys-users/edit-sys-users.component';
import { NewSysUsersComponent } from '../new-sys-users/new-sys-users.component';
import { ActivatedRoute, Router } from '@angular/router';
import { StationService } from '../services/stations.service';
import { InstallationService } from '../services/installation.service';

@Component({
  selector: 'ngx-sys-users',
  templateUrl: './sys-users.component.html',
  styleUrls: ['./sys-users.component.scss'],
})
export class SysUsersComponent implements OnInit {
  stationId: string;
  stationsUser: Array<object>;
  source: LocalDataSource;
  loading: boolean = false;

  settings = {
    actions: {
      position: 'right',
      columnTitle: 'Acciones',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/aleatorio.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 15,
    },
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
      email: {
        title: 'Email',
        filter: true,
      },
      role: {
        title: 'Rol',
        filter: true,
        valuePrepareFunction: (role) => {
          if (role === 'superadmin') {
            return 'Super Administrador/Dueño';
          } else if (role === 'admin') {
            return 'Administrador/Encargado';
          } else if (role === 'maintenanceUser') {
            return 'Usuario/Jefe de Mantenimiento';
          } else if (role === 'logbookUser') {
            return 'Usuario/Encargado de Bitácoras';
          } else if (role === 'viewAndDownloadOnly') {
            return 'Solo ver y descargar';
          } else {
            return '';
          }
        },
      },
      enabled: {
        title: 'Estatus',
        filter: false,
        type: 'html',
        valuePrepareFunction: (enabled) => {
          return `<img width="25px" class='table-thumbnail-img' src="${enabled ? 'assets/images/icons/active.png' : 'assets/images/icons/inactive.png'}"/>`;
        },
      },
    },
  };

  constructor(
    private sysUsersService: SysUsersService,
    private dialogService: NbDialogService,
    private route: ActivatedRoute,
    private router: Router,
    private stationService: StationService,
    private installationService: InstallationService,
  ) {
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.init();
    });
  }

  ngOnInit() {
    this.init();
  }

  async init() {
    await this.getUsersAll();
    const [error, { data }] = await this.installationService.getStations() as any;
    this.stationsUser = data;
  }

  async getUsers() {
    this.loading = true;
    const [error, { data: result }] = await this.sysUsersService.getUsers();
    if (error) return error;
    const users = result.filter(user => user.role === 'superadmin' || user.stations.includes(this.stationId));
    this.source = new LocalDataSource(users);
    this.loading = false;
  }

  async getUsersAll() {
    this.loading = true;
    const [error, { data: result }] = await this.sysUsersService.getUsersAll();
    this.loading = false;
    if (error) return this.alert('Oops ocurrio algo intenta mas tarde', 'error', 'Error al cargar los usuarios.');
    const stationUsers = await result.filter(user => user.stations.includes(this.stationId));
    this.source = new LocalDataSource(stationUsers.map(user => {
      if (user.enabled !== undefined && !user.enabled) return user;
      return { ...user, enabled: true };
    }));
  }

  openNewUser() {
    this.dialogService.open(NewSysUsersComponent, {
      hasScroll: true,
      context: {
        stationsUser: this.stationsUser,
        stationId: this.stationId,
      },
    }).onClose.subscribe(userStored => userStored ? this.getUsersAll() : null);
  }

  onCustom(event: any) {
    if (event.action === 'delete') {
      this.deleteUser(event.data);
    } else if (event.action === 'edit') {
      this.editUser(event.data);
    }
  }

  async editUser(user) {
    this.dialogService.open(EditSysUsersComponent, {
      hasScroll: true,
      context: {
        stationsUser: this.stationsUser,
        stationId: this.stationId,
        user: user,
      },
    }).onClose.subscribe(employeeUpdated => employeeUpdated ? this.getUsersAll() : null);
  }

  async deleteUser(user) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Cambia estatus entre activo/deshabilitado',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Cambiar',
    }).then(async (result) => {
      if (result.value) {
        const [error] = await this.sysUsersService.deleteUser(user.account, user.id, !user.enabled);
        // tslint:disable-next-line: max-line-length
        if (error) return this.alert('Ocurrio un error, intenta más tarde por favor', 'error');
        await this.getUsersAll();
        return this.alert('Estatus cambiado con éxito');
      }
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

}
